
class PlayerKeyDown {
    
    constructor(key) {
        this.key = key
    }
    
    getType() {
        return 'player_key_down'
    }
    
    getData() {
        return {
            key: this.key
        };
    }
    
}

export default PlayerKeyDown
